import nbccRoughnessTooltip from 'projectDesign/components/projectConfiguration/fieldsTooltips/nbccRoughnessTooltip';
export const apiField = 'nbcc_roughness';

export enum NBCCRoughness {
  ROUGH = 0,
  OPEN = 1
}

const options = [
  {
    value: NBCCRoughness.ROUGH,
    name: 'Rough',
  },
  {
    value: NBCCRoughness.OPEN,
    name: 'Open',
  },
]

const config = {
  label: 'nbccRoughness',
  type: 'Select',
  apiField,
  tooltip: nbccRoughnessTooltip,
  missing: undefined,
  data: options,
};


export default config;